// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"15ef0723","367":"04705eb6"}[chunkId] + ".chunk.css";
};